import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import Nestable from 'react-nestable'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'
import DeleteIcon from '../../../components/AllSvgIcon/DeleteIcon'
import EditIcon from '../../../components/AllSvgIcon/EditIcon'
import PlusIcon from '../../../components/AllSvgIcon/PlusIcon'
import HKBadge from '../../../components/Badges'
import Loader from '../../../components/Loader'
import CustomToast from '../../../components/Toast/CustomToast'
import TooltipComponent from '../../../components/Tooltip'
import { decodeId } from '../../../lib/AllGlobalFunction'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import axiosProvider from '../../../lib/AxiosProvider'
import { _SwalDelete } from '../../../lib/exceptionMessage'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import ChildMenuForm from './ChildMenuForm'
import SubmenuAdd from './SubmenuAdd'

const ManageHeader = () => {
  const [changeIdentifier, setChangeIdentifier] = useState({
    isSequenceUpadted: false,
    isSequenceChanged: false
  })
  const [childMenuModal, setChildMenuModal] = useState({
    show: false,
    isDataUpdated: false
  })
  const [editData, setEditData] = useState()
  const [searchParams] = useSearchParams()
  const encodedId = searchParams.get('id')
  const id = encodedId ? decodeId(encodedId) : null
  const [modalShow, setModalShow] = useState({
    show: false,
    isDataUpdated: false
  })
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState()
  const [data, setData] = useState()
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 0,
    pageIndex: 0,
    searchText: ''
  })
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  const { pageAccess } = useSelector((state) => state.user)
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle('Manage Sub Menu'))
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  const fetchData = async () => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'ManageSubMenu/byHeaderId',
      queryString: `?headerId=${id}&pageIndex=${filterDetails?.pageIndex}&pageSize=${filterDetails?.pageSize}`
    })
      .then((res) => {
        if (res.status === 200) {
          setItems(res?.data?.data)
          setData(res)
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const handleDelete = async (id) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'DELETE',
      endpoint: `ManageSubMenu?id=${id}`,
      userId,
      location: location.pathname
    })
      .then((res) => {
        if (res?.status === 200) {
          fetchData()
        }
        setToast({
          show: true,
          text: res?.data?.message,
          variation: res?.data?.code !== 200 ? 'error' : 'success'
        })
        setLoading(false)
        setTimeout(() => {
          setToast({ ...toast, show: false })
        }, 2000)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const handleEditData = async (id, parentId) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: parentId ? 'ManageChildMenu/byId' : 'ManageSubMenu/byId',
      queryString: `?id=${id}`
    })
      .then((res) => {
        if (res.status === 200) {
          parentId
            ? setChildMenuModal({ show: !childMenuModal?.show, parentId })
            : setModalShow({ show: !modalShow?.show })
          setEditData(res.data.data)
          // setInnitialData(false)
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  function renderItem({ item }) {
    return (
      <div
        className='main_nested'
        style={{
          backgroundColor: 'white'
        }}
      >
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
            <i className='m-icon m-icon--drag'></i> {item.name}
          </div>
          <div className='d-flex align-items-center gap-2'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageChildMenu,
              allCrudNames?.write
            ) && (
              <>
                {!item.parentId && (
                  <TooltipComponent toolplace='top' tooltipText='Create Child'>
                    <span
                      role='button'
                      className='d-flex'
                      onClick={() => {
                        setEditData()
                        setChildMenuModal({
                          ...childMenuModal,
                          show: !childMenuModal?.show,
                          parentId: item.id
                        })
                      }}
                    >
                      <HKBadge
                        badgesbgname={'primary'}
                        badgesTxtname={'Create Child'}
                        badgeClassname={''}
                      />
                    </span>
                  </TooltipComponent>
                )}
              </>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.manageSubMenu,
              allCrudNames?.update
            ) && (
              <span
                className='d-flex'
                onClick={() => {
                  if (changeIdentifier.isSequenceChanged) {
                    if (!changeIdentifier.isSequenceUpadted) {
                      Swal.fire({
                        title: 'Attention',
                        text: 'Please save the sequence for updating the data',
                        icon: _SwalDelete.icon,
                        showCancelButton: _SwalDelete.showCancelButton,
                        confirmButtonColor: _SwalDelete.confirmButtonColor,
                        cancelButtonColor: _SwalDelete.cancelButtonColor,
                        confirmButtonText: 'Change',
                        cancelButtonText: _SwalDelete.cancelButtonText
                      }).then((result) => {
                        if (result.isConfirmed) {
                          let data = items?.map((item, index) => {
                            const childSequence = item?.childMenu?.map(
                              (child, childIndex) => {
                                return {
                                  id: child?.id,
                                  parentId: item?.id,
                                  sequence: childIndex + 1
                                }
                              }
                            )
                            return {
                              sequence: index + 1,
                              id: item.id,
                              childSequence: childSequence ?? []
                            }
                          })
                          changeSequence(data).then((res) => {
                            if (res === 200) {
                              handleEditData(item.id, item.parentId)
                            }
                          })
                        } else if (result.isDenied) {
                        }
                      })
                    } else {
                      handleEditData(item.id, item.parentId)
                    }
                  } else {
                    handleEditData(item.id, item.parentId)
                  }
                }}
              >
                <EditIcon bg='bg' />
              </span>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.manageSubMenu,
              allCrudNames?.delete
            ) && (
              <span
                className='d-flex'
                onClick={() => {
                  Swal.fire({
                    title: _SwalDelete.title,
                    text: _SwalDelete.text,
                    icon: _SwalDelete.icon,
                    showCancelButton: _SwalDelete.showCancelButton,
                    confirmButtonColor: _SwalDelete.confirmButtonColor,
                    cancelButtonColor: _SwalDelete.cancelButtonColor,
                    confirmButtonText: _SwalDelete.confirmButtonText,
                    cancelButtonText: _SwalDelete.cancelButtonText
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleDelete(item.id)
                    } else if (result.isDenied) {
                    }
                  })
                }}
              >
                <DeleteIcon bg='bg' />
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }

  function updateParentId(items) {
    const updatedItems = []

    const nameSet = new Set()

    for (const item of items) {
      const updatedItem = { ...item }

      const childNames = updatedItem?.childMenu?.map((child) => child.name)
      const duplicateChildName = childNames.find(
        (name, index) => childNames.indexOf(name) !== index
      )

      if (duplicateChildName) {
        return `Error: Duplicate child menu name '${duplicateChildName}' found`
      }

      // Check for duplicate names at the current level
      if (nameSet.has(updatedItem.name)) {
        return `Error: Duplicate menu name '${updatedItem.name}' found`
      }

      nameSet.add(updatedItem.name)

      if (updatedItem?.childMenu && updatedItem.childMenu.length > 0) {
        updatedItem.childMenu = updatedItem?.childMenu?.map((child) => {
          if (child.parentId === null) {
            return { ...child, parentId: updatedItem.id }
          }
          return child
        })
      }

      updatedItems.push(updatedItem)
    }

    return updatedItems
  }

  function handleChange(updatedItems) {
    const itemsToBeUpdated = updateParentId(updatedItems?.items)
    if (typeof itemsToBeUpdated === 'string') {
      setToast({
        show: true,
        text: itemsToBeUpdated,
        variation: 'error'
      })
      setTimeout(() => {
        setToast({ ...toast, show: false })
      }, 2000)
      setItems(items)
      setChangeIdentifier({
        isSequenceUpadted: false,
        isSequenceChanged: false
      })
    } else {
      setChangeIdentifier({ isSequenceUpadted: false, isSequenceChanged: true })
      setItems(itemsToBeUpdated)
    }
  }

  const changeSequence = (data) => {
    return new Promise((resolve, reject) => {
      setLoading(true)

      axiosProvider({
        method: 'PUT',
        endpoint: 'ManageSubMenu/ChangeSequence',
        data,
        location: location?.pathname,
        userId,
        oldData: items
      })
        .then((response) => {
          setLoading(false)
          fetchData()
          if (response?.status === 200) {
            setChangeIdentifier({
              ...changeIdentifier,
              isSequenceUpadted: true
            })

            setToast({
              show: true,
              text: response?.data?.message,
              variation: response?.data?.code !== 200 ? 'error' : 'success'
            })

            setTimeout(() => {
              setToast({ ...toast, show: false })
            }, 2000)
          } else {
            setChangeIdentifier({
              ...changeIdentifier,
              isSequenceUpadted: false
            })
          }

          resolve(response.data.code) // Resolve the Promise after the asynchronous operations complete
        })
        .catch((error) => {
          setLoading(false)
          reject(error) // Reject the Promise if an error occurs
        })
    })
  }

  const handlePageClick = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  return (
    <>
      <div className='card'>
        {loading && !modalShow.show && <Loader />}
        {toast?.show && (
          <CustomToast text={toast?.text} variation={toast?.variation} />
        )}
        <div className='card-body'>
          <div className='d-flex align-items-center mb-3 gap-3 flex-row-reverse'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageSubMenu,
              allCrudNames?.write
            ) && (
              <Button
                variant='warning'
                className='d-flex align-items-center gap-2 fw-semibold'
                onClick={() => {
                  setEditData()
                  setModalShow({ ...modalShow, show: !modalShow.show })
                }}
              >
                <PlusIcon />
                Create Submenu
              </Button>
            )}
            {/* <div className='d-flex align-items-center me-2'>
              <label className='me-1'>Show</label>
              <select
                name='dataget'
                className='form-select me-1'
                onChange={(e) => {
                  setFilterDetails((draft) => {
                    draft.pageSize = e?.target?.value
                    draft.pageIndex = 1
                  })
                }}
              >
                <option value='10'>10</option>
                <option value='25'>25</option>
                <option value='50'>50</option>
                <option value='100'>100</option>
                <option value='200'>200</option>
                <option value='500'>500</option>
              </select>
            </div> */}
          </div>
          <Nestable
            items={items}
            renderItem={renderItem}
            handlerStyle={{ backgroundColor: 'gray' }}
            maxDepth={2}
            collapsed={false}
            childrenProp='childMenu'
            onChange={handleChange}
            renderItemIndex={() => null}
          />
          {modalShow.show && (
            <SubmenuAdd
              modalShow={modalShow}
              setModalShow={setModalShow}
              editData={editData}
              setEditData={setEditData}
              setToast={setToast}
              toast={toast}
              fetchData={fetchData}
            />
          )}

          {childMenuModal?.show && (
            <ChildMenuForm
              modalShow={childMenuModal}
              setModalShow={setChildMenuModal}
              editData={editData}
              setEditData={setEditData}
              setToast={setToast}
              toast={toast}
              fetchData={fetchData}
            />
          )}
          {items?.length > 0 ? (
            <div className='d-flex justify-content-start align-items-center mb-3'>
              <Button
                variant='primary'
                className='d-flex align-items-center gap-2 fw-semibold'
                onClick={() => {
                  Swal.fire({
                    title: 'Are you sure you want to change the sequence?',
                    text: _SwalDelete.text,
                    icon: _SwalDelete.icon,
                    showCancelButton: _SwalDelete.showCancelButton,
                    confirmButtonColor: _SwalDelete.confirmButtonColor,
                    cancelButtonColor: _SwalDelete.cancelButtonColor,
                    confirmButtonText: 'Confirm',
                    cancelButtonText: _SwalDelete.cancelButtonText
                  }).then((result) => {
                    if (result.isConfirmed) {
                      let data = items?.map((item, index) => {
                        const childSequence = item?.childMenu?.map(
                          (child, childIndex) => {
                            return {
                              id: child?.id,
                              parentId: item?.id,
                              sequence: childIndex + 1
                            }
                          }
                        )
                        return {
                          sequence: index + 1,
                          id: item.id,
                          childSequence: childSequence ?? []
                        }
                      })
                      changeSequence(data)
                    } else if (result.isDenied) {
                    }
                  })
                }}
              >
                Change Sequence
              </Button>
            </div>
          ) : (
            <h5 className='d-flex justify-content-center'>
              Record does not Exist.
            </h5>
          )}
        </div>
        {/* <ReactPaginate
          className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
          breakLabel='...'
          nextLabel=''
          onPageChange={handlePageClick}
          pageRangeDisplayed={pageRangeDisplayed}
          pageCount={data?.data?.pagination?.pageCount ?? 0}
          previousLabel=''
          renderOnZeroPageCount={null}
          forcePage={filterDetails?.pageIndex - 1}
        /> */}
      </div>
    </>
  )
}

export default ManageHeader
